import { LoaderFunction } from "react-router-dom";
import { getRecommendations } from "../../../../common/api/decimal/methods/recommendations.ts";

export type RecommendationsLoaderData = Awaited<
  ReturnType<typeof getRecommendations>
>;

export const recommendationsDataLoader: LoaderFunction = async ({
  request,
}) => {
  const url = new URL(request.url);
  const opts: Parameters<typeof getRecommendations>[0] = {};
  const createdAt = url.searchParams.get("createdAt");
  const cmp = url.searchParams.get("cmp");

  if (createdAt && cmp && ["gt", "gte", "lt", "lte"].includes(cmp)) {
    opts.createdAt = {
      isoDate: createdAt,
      cmp: cmp as "gt" | "gte" | "lt" | "lte",
    };
  }

  return getRecommendations(opts);
};
